import * as fromDatatype from "../datatype-library/index";

export interface alg_bot_cf_message_dfn_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  message_type: fromDatatype.VarcharDatatypeInterface;
  message_source: fromDatatype.VarcharDatatypeInterface;
  message_data_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_boolean: boolean;
  value_json: fromDatatype.JsonDatatypeInterface;
  template_message_guid: fromDatatype.GuidDataFieldInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class alg_bot_cf_message_dfn_RowClass implements alg_bot_cf_message_dfn_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  message_type: fromDatatype.VarcharDatatypeInterface;
  message_source: fromDatatype.VarcharDatatypeInterface;
  message_data_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_boolean: boolean;
  value_json: fromDatatype.JsonDatatypeInterface;
  template_message_guid: fromDatatype.GuidDataFieldInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
